<template>
  <div>
    <el-row>
      <el-col>
        <el-carousel trigger="click" height="500px">
          <el-carousel-item v-for="item in bannerList" :key="item.id">
            <img style="width: 100%; height: 100%;" :src="item.url" alt="">
          </el-carousel-item>
        </el-carousel>
      </el-col>
    </el-row>
    <el-row>
      <el-col class="product-list">
        <h2>产品和服务</h2>
        <div>
          <router-link tag="dl" to="/businessIntro?id=2" class="hidden-xs-only business-intro-item" v-for="item in productList" :key="item.id">
            <dd><img :src="item.img" alt=""></dd>
            <dt>
              <p class="product-title">{{ item.title }}</p>
              <p class="product-introduce">{{ item.introduce }}</p>
            </dt>
          </router-link>
          <el-carousel indicator-position="outside" :autoplay="3000" class="hidden-sm-and-up">
            <el-carousel-item v-for="item in productList" :key="item.id">
              <router-link tag="dl" to="/businessIntro" style="background: #F1F1F1; width: 335px; height: 268px;">
                <dd><img :src="item.img" style="width: 295px; height: 138px;" alt=""></dd>
                <dt>
                  <p class="product-title" style="color: #EA5714;">{{ item.title }}</p>
                  <p class="product-introduce" style="color: #EA5714;">{{ item.introduce }}</p>
                </dt>
              </router-link>
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <div class="footer">
        <div style="width: 1184px; margin: 0 auto;">
          <h3 class="footer-title">友情链接</h3>
          <div class="friendship-link-block">
            <div class="friendship-link-block-item">
              <a href="http://www.ecomm.com" target="_blank">
                <img style="width: 246px; height: 73px;" src="//static.yiteng288.com/ecomm/pages/winsway/public/logo1.png" alt="">
              </a>
            </div>
            <div class="friendship-link-block-item space-mark"></div>
            <div class="friendship-link-block-item">
              <a href="http://www.yee-link.com/" target="_blank">
                <img style="width: 260px; height: 42px;" src="//static.yiteng288.com/ecomm/pages/winsway/public/logo2.png" alt="">
              </a>
            </div>
            <div class="friendship-link-block-item space-mark"></div>
            <div class="friendship-link-block-item">
              <a href="https://ent.jizhiwuliu.cn" target="_blank">
                <img style="width: 227px; height: 73px;" src="//static.yiteng288.com/ecomm/pages/winsway/public/logo3.png" alt="">
              </a>
            </div>
          </div>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
 data() {
   return {
     bannerList: [
       {url: '//static.yiteng288.com/ecomm/pages/winsway/public/banner1.png', id: 1},
       {url: '//static.yiteng288.com/ecomm/pages/winsway/public/banner2.png', id: 2},
       {url: '//static.yiteng288.com/ecomm/pages/winsway/public/banner3.png', id: 3}
     ],
     productList: [
       {
         id: 1,
         img: '//static.yiteng288.com/ecomm/pages/winsway/public/160267617463820861901_488_276.png',
         title: '海关监管仓库',
         introduce: '甘其毛都口岸，海关监管场所，年吞吐能力1000万吨'
       },
       {
         id: 2,
         img: '//static.yiteng288.com/ecomm/pages/winsway/public/160267621523137926549_488_276.png',
         title: '综合物流服务',
         introduce: '“门到门”的一站式物流服务，路线覆盖中蒙跨境运输、内蒙古、山西、河北等区域'
       },
       {
         id: 3,
         img: '//static.yiteng288.com/ecomm/pages/winsway/public/160267623519120495583_488_276.png',
         title: '通关和质检',
         introduce: '提供进口代理、报关、报验等、物质检、货值评估等服务'
       },
       {
         id: 4,
         img: '//static.yiteng288.com/ecomm/pages/winsway/public/160267626804147769697_488_276.png',
         title: '智慧物流',
         introduce: '自主研发的YEE-WMS，通过物联网设备+线上平台，提升物流服务标准'
       }
     ]
   }
 }
}
</script>

<style scoped>
.product-list {
  padding: 40px 0;
}
.product-list h2 {
  text-align: center;
  padding-bottom: 25px;
}
.product-list dl {
  padding:5;
  padding-top: 20px;
  background: #FAFAFA;
  display: inline-block;
  vertical-align: middle;
  margin-right: 16px;
  width: 284px;
  height: 268px;
}
.product-list dl img {
  width: 244px;
  height: 138px;
}
.business-intro-item {
  background: #FAFAFA; 
  width: 335px; 
  height: 268px; 
  cursor: pointer;
  color: #6B6B81;
}
.business-intro-item:hover {
  background: #F1F1F1;
  color: #EA5714;
}
.business-intro-item:hover .product-title {
  color: #EA5714;
}
.product-title {
  color: #262634;
  font-size: 18px;
  padding: 3px 0;
  padding-top: 17px;
  font-weight: 500;
}
.product-introduce {
  font-size: 13px;
  padding: 0 20px;
  text-align: center;
}
.footer {
  background: url('//static.yiteng288.com/ecomm/pages/winsway/public/160272593265613959165_1920_556.png');
  height: 277px;
  width: 100%;
}
.footer-title {
  color: #fff;
  padding-top: 50px;
  text-align: left;
}
.friendship-link-block {
  background: rgba(35, 35, 58, 0.7);
  width: 100%;
  padding: 18px 0;
  margin: 30px 0 10px 0;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.space-mark {
  width: 1px;
  height: 49px;
  background: #EA5714;
}
.friendship-link-block-item {
  cursor: pointer;
}
.friendship-link-block-item img {
  width: 260px;
  height: 42px;
}
</style>